<template>
  <b-table 
    class="m-0"
    head-variant="light"
    thead-class="small"
    thead-tr-class="small text-uppercase"
    tbody-class="text-black"
    :items="items"
    :fields="fields">
    <template slot="field" slot-scope="data">
      <div class="skeleton">
        <div class="hidden-spacer"><slot></slot></div>
        <div class="placeholder thick"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="placeholder"></div>
        <div class="shimmer"></div>
      </div>
    </template>
  </b-table>
</template>

<style scoped>
.hidden-spacer {
  width: 1px;
  visibility: hidden !important;
}
.skeleton {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.placeholder {
  margin-right: 16px;
  background-color: #F7F8F9;
  border-radius: 5px;
  width: 100%;
  height: 10px;
}
.placeholder.thick {
  height: 20px;
  margin-right: 67px;
}
.shimmer {
  background-image: linear-gradient(90deg, rgba(255,255,255,0) 0px, #FFF 40px, rgba(255,255,255,0) 80px);
  background-size: 80px 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  animation: shine-lines 2s infinite ease-in-out;
}

@keyframes shine-lines {
  0% {
    left: -80px;
  }
  100% {
    left: 100%;
  }
}
</style>

<script>
export default {
  props: {
    fieldName: { type: String, default: "Field" }
  },
  data () {
    return {
      items: [
        { field: false },
        { field: false },
        { field: false },
        { field: false },
      ]
    }
  },
  computed: {
    fields () { 
      return [ { key: 'field', label: this.fieldName} ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/TableSkeleton.vue